import React, { useState } from 'react';
import { Button, Card, Grid, Loader, PageTitle } from '@develos/next-components';
import VehicleMPArgumentsContariner from './components/VehicleMPArgumentsContariner';
import { emptyReportFilter } from './constants';
import { ReportFilterType } from './types';
import FromToArgumentsContainer from './components/FromToArgumentsContainer';
import ReportConfigContainer from './components/ReportConfigContainer';
import PeriodConfigContainer from './components/PeriodConfigContainer';
import { useFetch, useInfoMessages, useTranslations } from '@develos/next-library';
import { useSelector } from 'react-redux';
import { storeSelectors } from '@/store';
import { VehicleWeightLimitFilterMode } from '@/store/portalSettings';

const Reports = () => {
  const [ filters , setFilters ] = useState<ReportFilterType>({...emptyReportFilter});
  const { postMutation } = useFetch();
  const { error } = useInfoMessages();
  const { translate } = useTranslations();
  const currentLocalization = useSelector(storeSelectors.selectCurrentMetricLocalization);
  const weightLimitFilterMode = useSelector(storeSelectors.selectWeightLimitFilterMode);

  const downloadReportMutation = postMutation(
    `Reports/CreateReport`, 
    { 
      blob: true,
      onError: () => {
        error(translate('GeneralOperation_EndsWithError'));
      },
     },
  );

  const toLocalISOString = (date: Date): string => {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}T${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
  };

  const generateReport = () => {
    const request = {
      ...filters,
      dates: {
        from: filters.dates.from ? toLocalISOString(filters.dates.from) : null,
        to: filters.dates.to ? toLocalISOString(filters.dates.to) : null,
      },
      vehicleRecordsRequest: {
        ...filters.vehicleRecordsRequest,
        metricLocalizationUid: currentLocalization!.uId,
      },
      vehiclesOver35TMode: weightLimitFilterMode == VehicleWeightLimitFilterMode.Above35Ton ? true : false
    }
    downloadReportMutation.mutate(request);
  }

  return (
    <div className='rm-relative rm-h-full rm-w-full'>
      <PageTitle title='Filtrowanie wyników' />
      <Card>
        <Card.Body>
          { downloadReportMutation.isPending && <Loader isAbsolute/> }
          <Grid gap={5} columns={1} mdColumns={12}>
            <VehicleMPArgumentsContariner filters={filters} setFilters={setFilters}/>
            <FromToArgumentsContainer filters={filters} setFilters={setFilters}/>
            <ReportConfigContainer filters={filters} setFilters={setFilters}/>
            <PeriodConfigContainer filters={filters} setFilters={setFilters}/>
          </Grid>
        </Card.Body>
        <Card.Footer>
          <Button
            handleClick={generateReport}
            disabled={downloadReportMutation.isPending}
          >
            Generuj raport
          </Button>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default Reports;
